import { useAppQuery } from "../../http/useAppQuery.ts";
import { TOOL_TO_GENERATION_TYPE } from "../Board/constants.ts";
import type { ModelCompatibleTool } from "../Board/types.ts";
import type { ModelWithIsCompatibleAndTags } from "../types.ts";
import { useWorkspaceUuid } from "./useWorkspaceUuid.ts";

export const useModels = ({
  tool,
  baseReferenceUuids,
}: {
  tool?: ModelCompatibleTool;
  baseReferenceUuids?: string[];
} = {}) => {
  const workspaceUuid = useWorkspaceUuid();
  const modelQuery = useAppQuery<ModelWithIsCompatibleAndTags[]>({
    queryKey: `workspaces/${workspaceUuid}/references`,
    queryParamsKey: {
      ...(tool && { generation_type: TOOL_TO_GENERATION_TYPE[tool] }),
      ...(baseReferenceUuids && { base_reference_uuids: baseReferenceUuids }),
    },
  });

  return {
    models: modelQuery.data ?? [],
    isLoading: modelQuery.isLoading,
  };
};
